import React from "react";
import ReactDOM from "react-dom";

import { connect } from "react-redux";
import { pushState, Link } from "react-router";
import { bindActionCreators } from "redux";
import { setGlobalKey, addUsers } from "../actions/General.js";
import {
    setCurrentUser,
    setCurrentAccount,
    setLoadedVisitors,
} from "../actions/Login.js";
import { switchChatStatus } from "../actions/Chat.js";
import SocketManager from "../modules/SocketManager";
import BrowserNotifications from "../components/BrowserNotification.js";
import Auth from "../modules/Auth";
import axios from "axios";
import moment from "moment";
import General from "../modules/General";
import GeneralHelper from "../helpers/General.js";
import Tooltip from "rc-tooltip";

import { HotKeys } from "react-hotkeys";
import CompanySearch from "../components/CompanySearch";
import {
    addCarts,
    chatSetGlobalKey,
    addVisitors,
    setInit,
    addPages,
} from "../actions/Chat";
import store from "../store";

import Confirm from "../components/Confirm.js";
import YesNo from "../components/YesNo.js";
import AcceptTerms from "../components/AcceptTerms.js";

const map = {
    toggleSearchCompany: "ctrl+shift+k",
    toggleFullScreen: "ctrl+shift+f",
};

class FullPage extends React.Component {
    constructor(props) {
        super(props);
        this.switchChatStatus = this.switchChatStatus.bind(this);
        this.toggleSidebar = this.toggleSidebar.bind(this);
        this.toggleSearchCompany = this.toggleSearchCompany.bind(this);
        this.switchAccount = this.switchAccount.bind(this);
    }

    toggleSidebar() {
        this.props.setGlobalKey("sidebarOpen", !this.props.general.sidebarOpen);
    }

    switchChatStatus(status) {
        SocketManager.setOnline(status);
    }

    toggleSearchCompany() {
        if (!Auth.isStaff()) {
            return;
        }
        this.props.setGlobalKey(
            "companySearchOpen",
            !this.props.general.companySearchOpen
        );
    }

    toggleDealerSearch = () => {
        this.props.setGlobalKey(
            "dealerSearchOpen",
            !this.props.general.dealerSearchOpen
        );
    };

    toggleFullScreen = () => {
        this.props.setGlobalKey("fullScreen", !this.props.general.fullScreen);
    };

    handleLogout(e) {
        e.stopPropagation();
        Auth.authenticate(false);
        this.props.setCurrentUser(false);
        this.props.router.push("/login");
    }

    componentWillMount() {
    }

    switchAccount(e, id) {
        e.stopPropagation();
        this.props.router.push("/" + id + "/dashboard");
        location.reload();
    }

    trialExpired() {
        if (this.props.general.account.expired == true && !Auth.isStaff()) {
            if (
                !this.props.router.isActive(
                    General.LinkIsActive("/settings/billing")
                )
            ) {
                this.props.router.push(
                    General.Link("/settings/billing/subscribe")
                );
            }
        }
    }

    onboardingComplete() {
        if (this.props.general.settings.ONBOARDING == 0) {
            if (!this.props.router.isActive(General.LinkIsActive("/setup"))) {
                this.props.router.push(General.Link("/setup"));
            }
        }
    }

    runChecks() {
        this.trialExpired();
        this.onboardingComplete();

        if (
            this.props.general.settings.ONBOARDING == 1 &&
            !localStorage.getItem("getting_started")
        ) {
            if (!this.props.router.isActive(General.LinkIsActive("/welcome"))) {
                this.props.router.push(General.Link("/welcome"));
            }
        }

        if (this.props.auth.loadedVisitors === false) {
            this.props.setLoadedVisitors(true);

            SocketManager.loadStaticVisitorList();
        }

        if (this.props.general.sidebarOpen) {
            document.body.classList.add("site-menubar-open");
            document.body.classList.remove("site-menubar-hide");
        } else {
            document.body.classList.remove("site-menubar-open");
            document.body.classList.add("site-menubar-hide");
        }
    }

    componentDidMount() {
        this.runChecks();
    }

    componentDidUpdate() {
        this.runChecks();
    }

    menuSettings() {
        return (
            <ul className="site-menu" data-plugin="menu">
                <li className="site-menu-category">Settings</li>

                <li className="site-menu-item">
                    <Link to={General.Link("/settings/me")}>
                        <i
                            className="site-menu-icon wb-user"
                            aria-hidden="true"
                        ></i>
                        <span className="site-menu-title">Profile</span>
                    </Link>
                </li>

                <li className="site-menu-item">
                    <Link to={General.Link("/settings/users")}>
                        <i
                            className="site-menu-icon wb-users"
                            aria-hidden="true"
                        ></i>
                        <span className="site-menu-title">Users</span>
                    </Link>
                </li>

                {this.props.general.settings.PACKAGE_CHAT == "1" ? (
                    <li className="site-menu-item">
                        <Link to={General.Link("/settings/chat")}>
                            <i
                                className="site-menu-icon wb-chat"
                                aria-hidden="true"
                            ></i>
                            <span className="site-menu-title">Chat</span>
                        </Link>
                    </li>
                ) : null}

                <li className="site-menu-item">
                    <Link to={General.Link("/settings/emails")}>
                        <i
                            className="site-menu-icon wb-envelope"
                            aria-hidden="true"
                        ></i>
                        <span className="site-menu-title">E-mails</span>
                    </Link>
                </li>

                <li className="site-menu-item">
                    <Link to={General.Link("/settings/company")}>
                        <i
                            className="site-menu-icon wb-briefcase"
                            aria-hidden="true"
                        ></i>
                        <span className="site-menu-title">Company</span>
                    </Link>
                </li>

                <li className="site-menu-item">
                    <Link to={General.Link("/settings/discount")}>
                        <i
                            className="site-menu-icon wb-tag"
                            aria-hidden="true"
                        ></i>
                        <span className="site-menu-title">Discount</span>
                    </Link>
                </li>

                <li className="site-menu-item">
                    <Link to={General.Link("/settings/billing")}>
                        <i
                            className="site-menu-icon wb-payment"
                            aria-hidden="true"
                        ></i>
                        <span className="site-menu-title">Billing</span>
                    </Link>
                </li>

                <li className="site-menu-item">
                    <Link to={General.Link("/settings/billing/invoices")}>
                        <i
                            className="site-menu-icon wb-order"
                            aria-hidden="true"
                        ></i>
                        <span className="site-menu-title">Invoices</span>
                    </Link>
                </li>

                <li className="site-menu-item">
                    <Link to={General.Link("/settings/sync")}>
                        <i
                            className="site-menu-icon wb-code-working"
                            aria-hidden="true"
                        ></i>
                        <span className="site-menu-title">Data sync</span>
                    </Link>
                </li>

                <li className="site-menu-item">
                    <Link to={General.Link("/events")}>
                        <i
                            className="site-menu-icon fa-list"
                            aria-hidden="true"
                        ></i>
                        <span className="site-menu-title">Events</span>
                    </Link>
                </li>

                <li className="site-menu-item m-t-20">
                    <Link to={General.Link("/dashboard")}>
                        <i
                            className="site-menu-icon wb-arrow-left"
                            aria-hidden="true"
                        ></i>
                        <span className="site-menu-title">Back</span>
                    </Link>
                </li>
            </ul>
        );
    }

    menuNormal() {
        return (
            <ul className="site-menu" data-plugin="menu">
                <li className="site-menu-category">General</li>

                    <li className="site-menu-item">
                        <a href={General.Link2("/dashboard")}>
                            <i
                                className="site-menu-icon wb-heart"
                                aria-hidden="true"
                            ></i>
                            <span className="site-menu-title">New admin</span>
                        </a>
                    </li>
                <li className="site-menu-item">
                    <Link to={General.Link("/dashboard")}>
                        <i
                            className="site-menu-icon wb-dashboard"
                            aria-hidden="true"
                        ></i>
                        <span className="site-menu-title">Dashboard</span>
                    </Link>
                </li>

                {this.props.general.settings.PACKAGE_CHAT == "1" ? (
                    <li className="site-menu-item hidden-sm-down">
                        <Link to={General.Link("/chat")}>
                            <i
                                className="site-menu-icon wb-chat"
                                aria-hidden="true"
                            ></i>
                            <span className="site-menu-title">Chat</span>
                        </Link>
                    </li>
                ) : null}

                <li className="site-menu-item">
                    <Link to={General.Link("/insights")}>
                        <i
                            className="site-menu-icon wb-graph-up"
                            aria-hidden="true"
                        ></i>
                        <span className="site-menu-title">Insights</span>
                    </Link>
                </li>


                <li className="site-menu-item m-t-10">
                    <a
                        href="https://support.mystore.no/no-no/knowledge/crall"
                        target="blank"
                    >
                        <i
                            className="site-menu-icon wb-help"
                            aria-hidden="true"
                        ></i>
                        <span className="site-menu-title">Help</span>
                    </a>
                </li>

                <li className="site-menu-item">
                    <a
                        onClick={(e) => this.handleLogout(e)}
                        href="javascript:void(0)"
                    >
                        <i
                            className="site-menu-icon wb-power"
                            aria-hidden="true"
                        ></i>
                        <span className="site-menu-title">Logout</span>
                    </a>
                </li>

                {this.props.auth.user.dealer_id ? (
                    <li className="site-menu-category">Dealer</li>
                ) : null}

                {this.props.auth.user.dealer_id ? (
                    <li className="site-menu-item">
                        <a
                            href="javascript:void(0)"
                            onClick={this.toggleDealerSearch}
                        >
                            <i
                                className="site-menu-icon wb-extension"
                                aria-hidden="true"
                            ></i>
                            <span className="site-menu-title">Customers</span>
                        </a>
                    </li>
                ) : null}
            </ul>
        );
    }

    renderMenuItems() {
        if (this.props.router.isActive(General.LinkIsActive("/settings"))) {
            return this.menuSettings();
        }

        if (this.props.router.isActive(General.LinkIsActive("/staff"))) {
            return this.menuStaff();
        }

        return this.menuNormal();
    }
    renderMenu() {
        let usage = parseInt(
            (this.props.general.settings.CURRENT_USAGE * 100) /
                this.props.general.settings.QUOTA
        );
        return (
            <div className="site-menubar">
                <div className="site-menubar-body">
                    <div>
                        <div>
                            {this.props.general.account.trial ? (
                                <div className=" ribbon-clip ribbon ribbon-reverse ribbon-danger">
                                    <span className="ribbon-inner">
                                        Trial ends{" "}
                                        {moment().to(
                                            this.props.general.account
                                                .trial_ends_at
                                        )}
                                    </span>
                                </div>
                            ) : null}

                            {this.props.general.settings.PACKAGE_CHAT == "1" ? (
                                <div
                                    className="site-menubar-section"
                                    style={{
                                        marginBottom: 0,
                                        textAlign: "center",
                                    }}
                                >
                                    <div className="btn-group" role="group">
                                        <button
                                            type="button"
                                            className="btn btn-dark dropdown-toggle"
                                            data-toggle="dropdown"
                                            aria-expanded="false"
                                        >
                                            {this.props.chat.isOnline ? (
                                                <span>
                                                    <i
                                                        className="icon wb-large-point"
                                                        style={{
                                                            color: "#1eb848",
                                                        }}
                                                        aria-hidden="true"
                                                    ></i>{" "}
                                                    Agent: Online
                                                </span>
                                            ) : (
                                                <span>
                                                    <i
                                                        className="icon wb-large-point"
                                                        style={{
                                                            color: "#b81e1e",
                                                        }}
                                                        aria-hidden="true"
                                                    ></i>{" "}
                                                    Agent: Offline
                                                </span>
                                            )}
                                        </button>
                                        <div
                                            className="dropdown-menu"
                                            style={{ width: "50%" }}
                                            role="menu"
                                        >
                                            <a
                                                className="dropdown-item"
                                                onClick={() =>
                                                    this.switchChatStatus(true)
                                                }
                                                role="menuitem"
                                            >
                                                <i
                                                    className="icon wb-large-point"
                                                    style={{ color: "#1eb848" }}
                                                    aria-hidden="true"
                                                ></i>{" "}
                                                Online
                                            </a>
                                            <a
                                                className="dropdown-item"
                                                onClick={() =>
                                                    this.switchChatStatus(false)
                                                }
                                                role="menuitem"
                                            >
                                                <i
                                                    className="icon wb-large-point"
                                                    style={{ color: "#b81e1e" }}
                                                    aria-hidden="true"
                                                ></i>{" "}
                                                Offline
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            ) : null}

                            {this.renderMenuItems()}

                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const handlers = {
            toggleSearchCompany: this.toggleSearchCompany,
            toggleFullScreen: this.toggleFullScreen,
        };

        let unreadMessages = 0;
        let yourConversations = 0;
        let unassignedConversations = 0;

        for (let i in this.props.chat.visitors) {
            let visitor = this.props.chat.visitors[i];
            if (visitor.assignee_id == this.props.auth.user.id) {
                yourConversations++;
            }

            if (visitor.assignee_id == 0 && visitor.started == 1) {
                unassignedConversations++;
            }

            if (
                (visitor.assignee_id == this.props.auth.user.id ||
                    visitor.assignee_id == 0) &&
                visitor.unreadMessages > 0
            ) {
                unreadMessages++;
            }
        }

        return (
            <HotKeys handlers={handlers} keyMap={map} focused>
                <div
                    className={`full-height ${
                        this.props.general.fullScreen ? "fullscreen-mode" : ""
                    }`}
                >
                    {this.props.general.showProcessing ? (
                        <div className="full-page-transparent-loading">
                            <div className="lds-ring">
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                            </div>

                            <div
                                style={{
                                    paddingLeft: "20px",
                                    fontWeight: "bold",
                                }}
                            >
                                Processing..
                            </div>
                        </div>
                    ) : null}

                    <nav
                        className="site-navbar navbar navbar-default navbar-fixed-top navbar-mega"
                        role="navigation"
                    >
                        <div className="navbar-header">
                            <button
                                type="button"
                                onClick={this.toggleSidebar}
                                style={{ zIndex: 3 }}
                                className="navbar-toggler hamburger hamburger-close navbar-toggler-left hided"
                                data-toggle="menubar"
                            >
                                <span className="sr-only">
                                    Toggle navigation
                                </span>
                                <span className="hamburger-bar"></span>
                            </button>
                            <button
                                type="button"
                                style={{ zIndex: 3 }}
                                className="navbar-toggler collapsed"
                                data-target="#site-navbar-collapse"
                                data-toggle="collapse"
                            >
                                <i
                                    className="icon wb-more-horizontal"
                                    aria-hidden="true"
                                ></i>
                            </button>
                            <div
                                className="navbar-brand navbar-brand-center site-gridmenu-toggle"
                                data-toggle="gridmenu"
                            >
                                <Link to={General.Link("/dashboard")}>
                                    <img
                                        className="navbar-brand-logo"
                                        src="/assets/images/logo.png"
                                    />
                                </Link>
                            </div>
                        </div>

                        <div className="navbar-container container-fluid">
                            <div
                                className="collapse navbar-collapse navbar-collapse-toolbar"
                                id="site-navbar-collapse"
                            >
                                <ul className="nav navbar-toolbar">
                                    <li className="nav-item hidden-float padding-button">
                                            <a
                                                href={General.Link2(
                                                    "/dashboard"
                                                )}
                                                className="btn btn-primary btn-sm"
                                            >
                                                <i
                                                    className="icon wb-heart"
                                                    aria-hidden="true"
                                                ></i>{" "}
                                                Go to new admin
                                            </a>
                                    </li>
                                    {SocketManager.isDisconnected() ? (
                                        <li
                                            style={{ marginLeft: "10px" }}
                                            className="nav-item hidden-float padding-button delay-rendering"
                                        >
                                            <Tooltip
                                                placement="top"
                                                overlay={
                                                    <span>
                                                        Connection between you
                                                        and our live update
                                                        server has been lost. If
                                                        the connection is down
                                                        for a long period, try
                                                        refreshing the page.
                                                    </span>
                                                }
                                            >
                                                <button className="btn btn-danger btn-sm">
                                                    <i
                                                        className="icon wb-warning"
                                                        aria-hidden="true"
                                                    ></i>{" "}
                                                    Connection error
                                                </button>
                                            </Tooltip>
                                        </li>
                                    ) : null}
                                </ul>

                                <ul className="nav navbar-toolbar navbar-right navbar-toolbar-right">
                                    <li className="nav-item">
                                        <Link
                                            className="nav-link"
                                            to={General.Link("/chat")}
                                        >
                                            <span
                                                className={
                                                    unreadMessages > 0
                                                        ? "tag tag-round tag-danger"
                                                        : "tag tag-outline tag-default"
                                                }
                                            >
                                                Unread messages:{" "}
                                                {unreadMessages}
                                            </span>
                                        </Link>
                                    </li>

                                    <li className="nav-item">
                                        <Link
                                            className="nav-link"
                                            to={General.Link("/chat")}
                                        >
                                            <span
                                                className={
                                                    unassignedConversations > 0
                                                        ? "tag tag-round tag-danger"
                                                        : "tag tag-outline tag-default"
                                                }
                                            >
                                                Unassigned conversations:{" "}
                                                {unassignedConversations}
                                            </span>
                                        </Link>
                                    </li>

                                    <li className="nav-item">
                                        <Link
                                            className="nav-link"
                                            to={General.Link("/chat")}
                                        >
                                            <span
                                                className={
                                                    yourConversations > 0
                                                        ? "tag tag-round tag-warning"
                                                        : "tag tag-outline tag-default"
                                                }
                                            >
                                                Your conversations:{" "}
                                                {yourConversations}
                                            </span>
                                        </Link>
                                    </li>

                                    <li className="nav-item dropdown logged-in-user">
                                        <a
                                            className="nav-link navbar-avatar"
                                            data-toggle="dropdown"
                                            href="javascript:void(0)"
                                            aria-expanded="false"
                                            data-animation="scale-up"
                                            role="button"
                                        >
                                            <span className="name">
                                                {this.props.auth.user.firstname}{" "}
                                                {this.props.auth.user.lastname}
                                                <strong>
                                                    {" "}
                                                    -{" "}
                                                    {this.props.general.account
                                                        .company
                                                        ? this.props.general
                                                              .account.company
                                                        : this.props.general
                                                              .account
                                                              .company_name}
                                                </strong>
                                            </span>
                                            <span className="avatar avatar-online">
                                                <img
                                                    src={
                                                        this.props.auth.user
                                                            .image
                                                    }
                                                />
                                                {this.props.chat.isOnline ==
                                                true ? (
                                                    <i></i>
                                                ) : null}
                                            </span>
                                        </a>
                                        <div
                                            className="dropdown-menu dropdown-menu-left"
                                            role="menu"
                                        >
                                            <Link
                                                to={General.Link("/settings")}
                                                className="dropdown-item"
                                                href="javascript:void(0)"
                                                role="menuitem"
                                            >
                                                <i
                                                    className="icon wb-settings"
                                                    aria-hidden="true"
                                                ></i>{" "}
                                                Settings
                                            </Link>


                                            <div
                                                className="dropdown-divider"
                                                role="presentation"
                                            ></div>
                                            <a
                                                className="dropdown-item"
                                                onClick={(e) =>
                                                    this.handleLogout(e)
                                                }
                                                href="javascript:void(0)"
                                                role="menuitem"
                                            >
                                                <i
                                                    className="icon wb-power"
                                                    aria-hidden="true"
                                                ></i>{" "}
                                                Logout
                                            </a>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </nav>

                    {this.renderMenu()}

                    <div className="page">
                        {BrowserNotifications.askForNotifications() === true ? (
                            <div
                                style={{
                                    margin: 0,
                                    borderRadius: 0,
                                    position: "relative",
                                    zIndex: "999",
                                    width: "100%",
                                }}
                                className="alert dark alert-alt alert-warning alert-dismissible"
                                role="alert"
                            >
                                <p>
                                    Crall needs your permissions to enable
                                    desktop notifications.
                                </p>
                                <p className="m-t-15">
                                    <button
                                        className="btn btn-warning btn-inverse btn-outline"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            BrowserNotifications.getPermission();
                                        }}
                                        type="button"
                                    >
                                        <i className="icon wb-check"></i>I want
                                        notifications
                                    </button>
                                    <button
                                        className="btn btn-link white"
                                        type="button"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            BrowserNotifications.dontAskAgain();
                                        }}
                                    >
                                        No, I don't want to be notified
                                    </button>
                                </p>
                            </div>
                        ) : null}

                        {this.props.children}
                    </div>

                    <YesNo
                        cancel="Stay offline"
                        accept="Go online"
                        onAccept={(e) => {
                            this.props.setGlobalKey(
                                "showChatReconnection",
                                false
                            );
                            this.switchChatStatus(true);
                        }}
                        onDecline={(e) => {
                            this.props.setGlobalKey(
                                "showChatReconnection",
                                false
                            );
                            this.switchChatStatus(false);
                        }}
                        onClose={(e) => {
                            this.props.setGlobalKey(
                                "showChatReconnection",
                                false
                            );
                        }}
                        param={this.props.general.showChatReconnection}
                        title="You are now offline"
                        body="You have been disconnected from the chat due to inactivity. Do you want appear online?"
                    />

                    {this.props.general.settings.ACCEPTED_TERMS != "1" ? (
                        <AcceptTerms
                            onAccept={(e) => {
                                location.reload();
                            }}
                            param={true}
                        />
                    ) : null}

                    {Auth.isStaff() && this.props.general.companySearchOpen ? (
                        <CompanySearch
                            router={this.props.router}
                            setCurrentAccount={this.props.setCurrentAccount}
                            setGlobalKey={this.props.setGlobalKey}
                            onClose={() => {
                                this.props.setGlobalKey(
                                    "companySearchOpen",
                                    false
                                );
                            }}
                            param={this.props.general.companySearchOpen}
                        />
                    ) : null}
                    {this.props.general.dealerSearchOpen ? (
                        <CompanySearch
                            router={this.props.router}
                            isDealer={true}
                            setCurrentAccount={this.props.setCurrentAccount}
                            setGlobalKey={this.props.setGlobalKey}
                            onClose={() => {
                                this.props.setGlobalKey(
                                    "dealerSearchOpen",
                                    false
                                );
                            }}
                            param={this.props.general.dealerSearchOpen}
                        />
                    ) : null}
                </div>
            </HotKeys>
        );
    }
}

const mapStateToProps = (state) => ({
    auth: state.auth,
    chat: state.chat,
    general: state.general,
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        {
            chatSetGlobalKey,
            addPages,
            addVisitors,
            addCarts,
            setInit,
            setLoadedVisitors,
            setGlobalKey,
            switchChatStatus,
            addUsers,
            setCurrentUser,
            setCurrentAccount,
        },
        dispatch
    );
};

FullPage = connect(mapStateToProps, mapDispatchToProps)(FullPage);
export default FullPage;



// WEBPACK FOOTER //
// ./containers/FullPage.js